import React from 'react'

const Service = (props) => {
    const {icon,title,description}=props.service;
  return (
    <div>
        <div>
            <div className="text-center p-10 h-64 border-r border-b border-[#2A3343]">
                <div className='hover:scale-110 duration-500'>
                     <img className="w-12 mx-auto" src={icon} alt="Services Icon" /> 
                    <h2 className="text-xl text-white my-3">{title}</h2>
                    <p className="text-base text-white">{description}</p>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Service